import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  connect() {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(this.element)
    } else {
      document.addEventListener('trustpilot-loaded', () => {
        window.Trustpilot.loadFromElement(this.element)
      })
    }
  }
}
